import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import gameStopIcon from '../../icons/adIcons/gamestop.png'
import cuddleClonesIcon from '../../icons/adIcons/cuddleClones.png'
import weBullIcon from '../../icons/adIcons/webull.png'
import upside from '../../icons/upside.webp'
import iBotta from '../../icons/ibotta2.webp'
import { Link } from 'react-router-dom'
import { updateAdTracker } from '../../store/actions/restaurantActions'

function handleMainClick(link, dispatch){
  dispatch(updateAdTracker(link));
  window.open(link);
}

function newWindow(url) {
    var newWind = window.open('http://' + url, '_blank');
    newWind.opener = null;
  }

function AdSummary({ adInformation, adNumber }) {
  
  var [ad, setAd] = useState({
    id: "iaosdng350384",
    name: "weBull",
    icon: "weBullIcon",
    iconPadding: "50%",
    iconSize: 35,
    blurb: "Sign up and get 5 free stocks!  Two stocks valued  $3 - $300 and three stocks valued $7 -$3000 when you fund your account with any amount.  Cash out or reinvest after trades clear (2-3 days).",
    link: 'https://a.webull.com/6rhTVvkcKziAJOU5Cw',
    promotions: 'Sign up and get 5 free stocks!  Each valued between $3 - $3000.',
    images: ''
  })

  const dispatch = useDispatch();
  const iconTable = {
    gameStopIcon: gameStopIcon,
    cuddleClonesIcon: cuddleClonesIcon,
    weBullIcon: weBullIcon,
    upside: upside,
    iBotta: iBotta
  }

  const selectAds = useSelector((state)=>state.firestore.ordered.advertisements2);
  const ad2 = selectAds && selectAds[adInformation];

  // const [iconImage, setIconImage] = useState(iconTable[ad.icon]);
  // const [iconPadding, setIconPadding] = useState(ad.iconPadding);
  // const [iconSize, setIconSize] = useState(ad.iconSize);
  const [lastClicked, setLastClicked] = useState(ad.blurb);
  // const [adLink, setAdLink] = useState(ad.link);
  // const [adName, setAdName] = useState(ad.name);
  // lol this is so wrong
  useEffect(()=>{if(ad2 !== undefined && ad !== ad2){
    setAd(ad2);
    if(ad2.images === ""){
      setLastClicked(ad2.blurb);  
    }
    else{
      setLastClicked(ad2.images);
    }
    
    //console.log('update ad ' + adInformation);
    }
  },[ad2, ad.blurb])

  return (
  <div className="grid-test">
    <div className='tagIcon' onClick={ () => handleMainClick(ad.link, dispatch) } ><img alt="Tag Icon" style={{"marginTop":ad.iconPadding}} height={ad.iconSize} src={iconTable[ad.icon]}/></div>
    <div className='image-stack'>
      <div className="new-wrapper">
          <div className="new-nav-text2">
              <div><a onClick={ () => {setLastClicked(ad.blurb); handleMainClick(ad.link, dispatch);} }>{ad.name}</a></div>
          </div>

          {<div className="new-nav-text">
              <div><a onClick={ () => {setLastClicked(ad.promotions);} }>Promotions</a></div>
              <div><a onClick={ () => setLastClicked(ad.images) }>Images</a></div>
              {/*<div><a onClick={ () => this.setState({newLastClicked: 'address'}) }>Address</a></div>
              <Link to={'/edit/' + project.restaurantId} key={project.restaurantId}>Edit</Link>
              <div><img src={favIcon} onClick={() => this.onFavorite(project)} className="favIcon" alt="star" width="20px" height="20px" viewBox="0 0 20 20"/></div>  */}
              
          </div>}
          
          <div className="new-main" id={"contentBox"+ad.id} style={{overflowY:"auto"}} onClick={ () => handleMainClick(ad.link, dispatch) }>
            <div>
              { lastClicked !== ad.images &&
                <p>{ lastClicked }</p>
              }
              { lastClicked === ad.images && ad.images !== "" &&
                <img alt='ad image' className="mapImage" src = {ad.images}/>
              }
              {/*{ lastClicked === ad.images && adNumber !== undefined &&
               <img alt='ad image' className="mapImage" src = {ad.images[adNumber]}/> 
              }*/}
              { lastClicked === ad.images && ad.images === "" &&
                <img alt="Tag Icon" style={{"paddingRight":ad.iconPadding}} height={ad.iconSize} src={iconTable[ad.icon]}/>
              }   
              
            </div>

            {/*<p> { this.state.lastClicked===project.address && this.state.mapUrl!=='' && <img alt='Map' className="mapImage" src = {this.state.mapUrl}/> } </p>
            <p> { this.state.lastClicked==='Click or tap on a review to expand.' && <Link to={{pathname: '/reviews/' + project.restaurantId, state: {project: project}}} key={'review'+project.restaurantId}>Write a review</Link>  } </p>
            {
             this.state.lastClicked==='Click or tap on a review to expand.' && this.props.firestore.data.restaurantReviews2 && this.state.reviewer &&
              this.state.reviewer
            }*/}
          </div>
          <div className="new-bottom">
            <div><a onClick = {() => handleMainClick(ad.link, dispatch)}>Website</a></div>
            <div><Link to={{pathname: '/about/points'}} key={'link'}>Disable Ads</Link>  </div>
            <div><a onClick = {() => setLastClicked(ad.blurb)}>About</a></div>
          </div>

      </div>
    </div>
  </div>
  );
}

export default AdSummary;